/* eslint-disable react/jsx-max-depth */
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
// import queryString from 'querystring';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import { Flex, Modal, Text, Accordion, Grid } from '@mantine/core';
import { AppContext } from '../../contexts';
import { submitUploadUpdatePriceSubUser } from './actions';
import FormSettingHargaSekaligusSubPangkalan from './FormSettingHargaSekaligusSubPangkalan';
import IconSuccess from '../../components/icons/IconSuccess';
import IconFailed from '../../components/icons/IconFailed';
import styles from './styles.scoped.css';

export function SettingSekaligusSubPangkalan(
  // {
  // handleSubmit = () => {}
  // }
) {
  const dispatch = useDispatch();

  const { setBreadcrumbs } = useContext(AppContext);
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('');

  useEffect(() => {
    setBreadcrumbs([
      'Atur HET LPG 3 Kg',
      { name: 'Subpangkalan', to: '/price?tab=subpangkalan' },
      'Ubah Harga Dengan File',
    ]);
  }, []);

  const {
    dataUploadUpdatePriceSubUser,
    messageUploadUpdatePriceSubUser,
    isLoadingUploadUpdatePriceSubUser,
  } = useSelector((s) => s.prices);

  const handleDownloadDataFailRegist = () => {
    let a = document.createElement('a');
    a.href = messageUploadUpdatePriceSubUser?.link;
    a.click();
    setOpenModal(false);
  };

  const onBack = () => {
    let a = document.createElement('a');
    a.href = '/dc/price?tab=subpangkalan';
    a.click();
    setOpenModal(false);
  };

  useEffect(() => {
    if (
      afterSubmit &&
      messageUploadUpdatePriceSubUser !== '' &&
      messageUploadUpdatePriceSubUser !== undefined
    ) {
      if (messageUploadUpdatePriceSubUser === 'Template Update Harga Tidak Sesuai') {
        setOpenModal(true);
        setModalMode('somethingWrong');
      } else {
        setOpenModal(true);
        setModalMode('fail');
      }
    } else if (
      afterSubmit &&
      messageUploadUpdatePriceSubUser === '' &&
      !isLoadingUploadUpdatePriceSubUser &&
      dataUploadUpdatePriceSubUser?.failedData?.length === 0
    ) {
      setOpenModal(true);
      setModalMode('success');
    } else if (
      afterSubmit &&
      !isLoadingUploadUpdatePriceSubUser &&
      dataUploadUpdatePriceSubUser?.failedData?.length > 0
    ) {
      setOpenModal(true);
      setModalMode('successWithFail');
    }
  }, [dataUploadUpdatePriceSubUser, messageUploadUpdatePriceSubUser]);

  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        <FormSettingHargaSekaligusSubPangkalan
          onSubmit={(values) =>
            dispatch(submitUploadUpdatePriceSubUser(values, setAfterSubmit(true)))
          }
        />
      </Card>
      <Modal
        centered
        onClose={() => setOpenModal(false)}
        opened={openModal}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles['modal-res-upload']} style={{ textAlign: 'center' }}>
          <span onClick={() => setOpenModal(false)}>
            <img className={styles['close-icon-modal']} src="assets/ic-close.svg" />
          </span>
          {modalMode === 'successWithFail' ? (
            <>
              <h5>Sebagian data berhasil diunggah</h5>
              <hr className={styles.separatirModal} />
              <Flex direction="column" gap="md" mt="md">
                <Card p="sm" radius="md" sx={{ padding: '10px' }} withBorder>
                  <Flex align="center" direction="row" gap="sm" pl={10} sx={{ padding: '.3rem 1rem .3rem 1.25rem' }}>
                    <IconSuccess type={'small'} />
                    <Text>
                      {dataUploadUpdatePriceSubUser?.successTotal} HET Berhasil Ditambahkan
                    </Text>
                  </Flex>
                </Card>
                <Accordion radius="md" variant="contained">
                  <Accordion.Item value="print">
                    <Accordion.Control icon={<IconFailed type={'small'} />} py=".2rem">
                      {dataUploadUpdatePriceSubUser?.failedTotal} HET Gagal Ditambahkan
                    </Accordion.Control>
                    <Accordion.Panel mx="sm" sx={{ borderTop: '1px solid #D9DEE4' }}>
                      {dataUploadUpdatePriceSubUser?.failedData?.map((item, index) => (
                        <Grid grow key={index} mt="sm">
                          <Grid.Col span={4}>
                            <Text fz={14} ta="left">
                              ID Registrasi {item.registrationId}
                            </Text>
                          </Grid.Col>
                          <Grid.Col span={4}>
                            <Text fz={14} sx={{ color: '#CF212A' }} ta="right">
                              {item.reason}
                            </Text>
                          </Grid.Col>
                        </Grid>
                      ))}
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>
                <Button fullWidth onClick={() => setOpenModal(false)}>
                  Tutup
                </Button>
              </Flex>
            </>
          ) : (
            <h5>Unggah {modalMode === 'success' ? 'Berhasil' : 'Gagal'}</h5>
          )}
          {modalMode === 'fail' && (
            <p>Data gagal diupload. Segera perbaiki data yang gagal dan unggah kembali.</p>
          )}
          {modalMode === 'somethingWrong' && (
            <p>File yang diunggah tidak sesuai format, segera periksa data dan unggah kembali</p>
          )}
          {modalMode === 'success' && (
            <Button className={styles['action-btn-modal']} onClick={onBack}>
              Oke
            </Button>
          )}
          {modalMode === 'fail' && (
            <Button
              className={styles['action-btn-modal']}
              onClick={() => handleDownloadDataFailRegist()}
            >
              Tutup dan Unduh Data Gagal
            </Button>
          )}
          {modalMode === 'somethingWrong' && (
            <Button
              className={styles['action-btn-modal']}
              onClick={() => {
                setOpenModal(false), setAfterSubmit(false);
              }}
            >
              Ok
            </Button>
          )}
        </div>
      </Modal>
    </div>
  );
}

SettingSekaligusSubPangkalan.propTypes = {
  handleSubmit: PropTypes.func,
};
export default SettingSekaligusSubPangkalan;
